"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgImage = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M31 14a3 3 0 013 3v14a3 3 0 01-3 3H17l-.058-.002h-.001L17 34a3 3 0 01-3-3V17a3 3 0 013-3h14zm-3 9.414L19.414 32H31a1 1 0 001-1v-3.585l-4-4zM31 16H17a1 1 0 00-1 1v14a1 1 0 00.65.937l10.643-10.644a1 1 0 011.414 0L32 24.585V17a1 1 0 00-1-1zm-10.5 2a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm0 2a.5.5 0 100 1 .5.5 0 000-1z",
    id: "image_svg__a"
  }));
};

var _default = SvgImage;
exports.default = _default;